// extracted by css-extract-rspack-plugin
export default {"wrapper":"UserDropButton-module__wrapper--m_VK0"};